import { generateID } from './id.js';

const initBooking = (orderID, patientID) => Object.assign(Object.assign({
  creationTimestamp: Date.now(),
  id: generateID()
}, patientID ? {
  patientID
} : undefined), {
  orderID
});

export { initBooking };
